module.exports = __webpack_public_path__ + "static/media/transfer_a_person_map_important.b4309176.svg";